<template>
  <div :key="`${name}--wrapper`" class="lad-autocomplete-search-wrapper">
    <component
      :is="searchTypeComponent"
      :key="`${name}--input`"
      :name="name"
      :submit="submit"
      :search="search"
      @on-blur="handleBlur"
      @on-focus="handleFocus"
      @on-change="handleChange"
      @on-loading="handleLoading"
      @is-valid="handleIsValid"
    />
  </div>
</template>

<script>
export default {
  name: 'LadAutocompleteSearch',
  components: {
    LadSearchAdvanced: () =>
      import(
        /* webpackChunkName: "lad-search-advanced" */ './components/type/advanced'
      ),
    LadSearchCustom: () =>
      import(
        /* webpackChunkName: "lad-search-custom" */ './components/type/custom'
      ),
    LadSearchBasic: () =>
      import(
        /* webpackChunkName: "lad-search-basic" */ './components/type/basic'
      ),
  },
  props: {
    advanced: { type: Boolean, default: false },
    custom: { type: Boolean, default: false },
    submit: { type: Number, default: 0 },
    name: { type: String, required: true, default: '' },
    search: { type: String, default: '' },
  },
  computed: {
    searchTypeComponent() {
      let type = this.advanced ? 'Advanced' : 'Basic'

      if (this.custom) type = 'Custom'

      return `LadSearch${type}`
    },
  },
  methods: {
    handleBlur() {
      this.$emit('on-blur')
    },
    handleFocus() {
      this.$emit('on-focus')
    },
    handleLoading(value) {
      this.$emit('on-loading', value)
    },
    handleChange(value) {
      this.$emit('on-change', value)
    },
    handleIsValid(value) {
      this.$emit('is-valid', value)
    },
  },
}
</script>
